import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/provide/auth.service';
import { CommonService } from 'src/app/provide/common.service';
@Component({
    selector: 'app-customer-category-list',
    templateUrl: './customer-category-list.component.html',
    styleUrls: ['./customer-category-list.component.scss'],
    standalone: false
})
export class CustomerCategoryListComponent implements OnInit {
  _id: any;
  currentPage = 1;
  pageSize = 30; // Changed from 15 to 30 as per requirement
  serviceName: any;
  loggedInUserType: any;
  headingName: any = 'CATEGORY'
  linkerRouteItems: any = [
    { name: 'Home', route: '/home' },
    // { name: 'Categroy', route: '/customer-category-list' }
    { name: 'Categories', route: '/customer-category-list' }
  ]
  
  // Dropdown state
  isDropdownOpen = false;
  
  constructor(
    private activatedroute: ActivatedRoute,
    public commonService: CommonService,
    private router: Router,
    public authService: AuthService
  ) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this._id = res._id;
    });
  }

  ngOnInit(): void {
    this.authService.loggedInUserType.subscribe((res: any) => {
      this.loggedInUserType = res;
    });
    this.loggedInUserType = this.authService.checkUserTypeLoggedIn();
    this.getServiceList();
  }
  
  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = document.querySelector('.see-more-dropdown');
    
    if (dropdown && !dropdown.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

  userId: any;
  productDetails: any;
  productId: any;
  retailerId: any;
  imgurl: any;
  imageLinks: any;
  totalItems: any;
  isLoading: boolean = false;
  
  // Toggle dropdown visibility
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  
  // Close dropdown
  closeDropdown() {
    this.isDropdownOpen = false;
  }
  
  // Pagination methods
  goToPage(page: number) {
    console.log('Going to page:', page, 'Current page:', this.currentPage, 'Total pages:', this.getTotalPages());
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
      this.getServiceList();
    }
  }
  
  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const pages: number[] = [];
    const startPage = Math.max(1, this.currentPage - 2);
    const endPage = Math.min(totalPages, this.currentPage + 2);
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    console.log('Page numbers:', pages, 'Total pages:', totalPages, 'Current page:', this.currentPage);
    return pages;
  }
  
  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }
  
  // get retailer detail by id
  flag : boolean = true
  getServiceList() {
    let apiReqUrl: any = `admin/listCategory`;
    let apiReqData = {
      search: this.serviceName,
      page: String(this.currentPage),
      limit: String(this.pageSize),
    };
    this.commonService.removeEmptyKey(apiReqData);
    // let apiReqUrl: any = `${ApiEndPoint.productView + '?productId=' + this.productId}`
    if (!this.serviceName) {

      // this.commonService.showSpinner();
    }
    this.flag = true
    this.commonService.postApi(apiReqUrl, apiReqData, 0).subscribe(
      (res: any) => {
        if (res.responseCode == 200) {
          this.productDetails = res.result.docs;
          if (!this.productDetails.length) {
            this.isLoading = true;
          } else {
            this.isLoading = false;
          }
          this.totalItems = res.result.total;
          this.imageLinks = res['result']['thumbnail'];
          console.log('Total items:', this.totalItems, 'Page size:', this.pageSize, 'Should show pagination:', this.totalItems > this.pageSize);
          this.commonService.hideSpinner();
        } else {
          this.isLoading = true;
          this.flag = false
          this.productDetails = [];
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
        }
      },
      (err) => {
        this.isLoading = true;
        this.flag = false
        this.productDetails = [];
        this.commonService.hideSpinner();
        this.commonService.errorToast(err.responseMessage);
      }
    );
  }
  navigateToViewProduct(_id, categoryName) {
    // Close dropdown when navigating
    this.closeDropdown();
    
    if (this.loggedInUserType == 'RETAILER') {
      this.router.navigate(['/retailer-category-list-view'], {
        queryParams: { _id: _id, categoryName: categoryName },
      });
    } else {
      this.router.navigate(['/customer-category-list-view'], {
        queryParams: { _id: _id, categoryName: categoryName },
      });
    }
  }
  pagination(event) {
    this.currentPage = event;
    this.getServiceList();
  }
  length(n){
    return new Array(n)
  }
  
  // Expose Math to template
  Math = Math;
}